export const SCHEDULE_A_MEASURE_CONTACT_NUMBER = '1-855-632-7873';